import { Flex } from 'antd';
import { groupBy } from 'lodash';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import LynIcon from 'components/@extended/LynIcon';
import TabPanel from 'components/TabPanel/TabPanel';
import plusIcon from 'assets/images/icons/plus.svg';
import { a11yProps, TabsItemThree as TabsItem } from 'pages/globals/global';
import comptroller from 'assets/images/comptroller_white.svg';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ListViewProcessRoleMaster from './ListView-ProcessRoleMaster';
import { useGetProcessPositionMutation } from 'store/features/process/processApi';
import { Box, Button, Grid, Stack, Tab, Tabs, Typography, useMediaQuery } from '@mui/material';

const ProcessRoleMaster = () => {
	const theme = useTheme();
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();

	const [reloadTable, setReloadTable] = useState(false);
	const [activeCreateButton, setActiveCreateButton] = useState(true);
	const [processRoleMasterList, setProcessRoleMasterList] = useState([]);
	const [existingProcessNameMap, setExistingProcessaNameMap] = useState([]);
	const [selectedTab, setSelectedTab] = useState(() => {
		const activeTab = searchParams.get('tab');

		if (activeTab) {
			const index = TabsItem?.findIndex((item) => item?.label === activeTab);

			if (index < 0) return navigate('/static/process-role', { replace: true });
			return index;
		}

		return 0;
	});

	const { profileData } = useSelector((state) => state?.profile);
	const [GetProcessPosition, { data: getProcessList, isLoading }] = useGetProcessPositionMutation();

	const matchDownSM = useMediaQuery((theme) => theme.breakpoints.down('sm'));

	const selectTabHandler = (event, newValue) => {
		setSelectedTab(newValue);

		const tabName = TabsItem?.[newValue]?.label;

		navigate(`/static/process-role?tab=${tabName}`, { replace: true });
	};

	useEffect(() => {
		setActiveCreateButton(isLoading);
	}, [isLoading]);

	useEffect(() => {
		if (profileData) {
			GetProcessPosition({
				companyCode: profileData?.creatorOrganizationId,
			});
		} //eslint-disable-next-line
	}, [reloadTable]);

	useEffect(() => {
		if (getProcessList?.status === 'SUCCESS' && getProcessList?.lynPositionList && getProcessList?.lynPositionList?.length > 0) {
			// setProcessRoleMasterList(getProcessList?.lynPositionList);
			const arr1 = groupBy(getProcessList?.lynPositionList, 'activationStatus');

			arr1['All'] = getProcessList?.lynPositionList ?? [];

			setProcessRoleMasterList(arr1);

			let temp = [];
			getProcessList?.lynPositionList?.map((item) => {
				temp[item?.positionCode] = item;
				return item;
			});

			setExistingProcessaNameMap(temp);
		}
	}, [getProcessList]);

	useEffect(() => {
		const activeTab = searchParams.get('tab');

		if (activeTab) {
			const index = TabsItem?.findIndex((item) => item?.label === activeTab);

			if (index === -1) navigate('/static/process-role', { replace: true });
		}
	}, []);

	return (
		<Grid container rowSpacing={4.5} columnSpacing={2.75}>
			<Grid item xs={12}>
				<Box
					sx={{
						width: '100%',
						borderRadius: 1,
					}}
				>
					<Box sx={{ bgcolor: '#214689', borderRadius: 1, pl: '10px', pr: '8px', py: '8px', color: 'common.white', mb: '25px' }}>
						<Flex justify="space-between" align="center">
							<Stack direction="row" alignItems="center" sx={{ gap: '10px' }}>
								<img alt="comptroller" src={comptroller} width="18px" height="18px" />
								<Typography variant="h4">Process Roles</Typography>
							</Stack>

							{/* <Button style={{ backgroundColor: activeCreateButton ? "gray" : theme.palette.lynTheme.success, boxShadow: "none", border: "1px solid", borderColor: "#ffff", fontWeight: 600, display: "flex", alignItems: "center" }} disabled={activeCreateButton} type="primary" size="large" onClick={() => navigate("/static/process-role/create", { state: { existingProcessNameMap } })}>
                <img src={plusIcon} alt="add" width="14" height="14" style={{ marginRight: "8px" }} />
                Create
              </Button> */}

							<Button
								sx={{
									color: 'white',
									fontWeight: 450,
									display: 'flex',
									boxShadow: 'none',
									padding: '3px 15px',
									alignItems: 'center',
									transition: 'all 0.3s',
									border: `1px solid ${activeCreateButton ? 'gray' : theme.palette.lynTheme.success}`,
									borderColor: '#ffff',
									backgroundColor: activeCreateButton ? 'gray' : theme.palette.lynTheme.success,
									'&:hover': {
										backgroundColor: activeCreateButton ? 'gray' : '#207f3b',

										transform: 'scale(0.9)',
									},
								}}
								type="primary"
								disabled={activeCreateButton}
								onClick={() => navigate('/static/process-role/create', { state: { existingProcessNameMap } })}
							>
								<img src={plusIcon} alt="add" width="12" height="12" style={{ marginRight: '8px' }} />
								Create
							</Button>
						</Flex>
					</Box>

					<Box sx={{ width: '100%', backgroundColor: 'white' }} style={{ borderRadius: '0px 0px 6px 6px' }}>
						<Tabs
							value={selectedTab}
							sx={{
								'& .MuiTabs-indicator': {
									backgroundColor: '#214689',
									borderRadius: '0px 0px 0px 6px',
								},
								'& .Mui-selected': {
									color: '#214689',
								},

								'& .MuiTab-root': {
									backgroundColor: 'white',
									opacity: 1,
								},
							}}
							scrollButtons
							textColor="inherit"
							allowScrollButtonsMobile
							onChange={selectTabHandler}
							aria-label="basic tabs example"
							variant={matchDownSM ? 'scrollable' : 'standard'}
						>
							<Tab
								key="Active"
								label="Active"
								iconPosition="start"
								icon={<LynIcon folder="icons" fileName="active" format="svg" sx={{ marginRight: '16px' }} />}
								sx={{
									width: '176px',
								}}
								{...a11yProps(0)}
							/>
							<Tab
								key="Inactive"
								label="Inactive"
								iconPosition="start"
								icon={<LynIcon folder="icons" fileName="deactivated" format="svg" sx={{ marginRight: '16px' }} />}
								sx={{
									width: '176px',
								}}
								{...a11yProps(2)}
							/>
							<Tab
								key="All"
								label="All"
								iconPosition="start"
								icon={<LynIcon folder="icons" fileName="all" format="svg" sx={{ marginRight: '16px' }} />}
								sx={{
									width: '176px',
								}}
								{...a11yProps(2)}
							/>
						</Tabs>
					</Box>
				</Box>

				<Box sx={{ borderBottom: 1, borderColor: 'divider', width: '100%' }}>
					{TabsItem?.filter((item) => item?.data !== 'W-I-P')?.map((item, index) => (
						<TabPanel key={index} value={selectedTab} index={index} sx={{ height: 'calc(100% - 38px)' }}>
							<Box sx={{ mt: 2 }}>
								<ListViewProcessRoleMaster
									setReloadTable={setReloadTable}
									isLoading={isLoading}
									processRoleMasterList={processRoleMasterList[item?.data] ? processRoleMasterList[item?.data] : []}
									existingProcessNameMap={existingProcessNameMap}
								/>
							</Box>
						</TabPanel>
					))}
				</Box>
			</Grid>
		</Grid>
	);
};
export default ProcessRoleMaster;
